import { gql } from '@apollo/client';
import BaseService from './baseService';

class AddressTypesService extends BaseService {
  constructor() {
    super();
    this.addressTypeGql = `
      addressTypeId
      addressType
    `;
    this.companyAddressTypeGql = `
      addressTypeId
      addressType
    `;
  }

  getAddressTypes = () => new Promise((resolve, reject) => {
    const ADDRESS_TYPES = gql`
      query {
        addressTypes{
            ${this.addressTypeGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: ADDRESS_TYPES
      })
      .then((result) => {
        if (result.data.addressTypes) {
          resolve(result.data.addressTypes);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getClientAddressTypes = () => new Promise((resolve, reject) => {
    const ADDRESS_TYPES = gql`
      query {
        companyAddressTypes{
            ${this.companyAddressTypeGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: ADDRESS_TYPES
      })
      .then((result) => {
        if (result.data.companyAddressTypes) {
          resolve(result.data.companyAddressTypes);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const addressTypesService = new AddressTypesService();

export default addressTypesService;
